import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';
import { UiCardPadding } from '../../types/ui-card-padding.type';

@Component({
  selector: 'ui-card',
  imports: [],
  templateUrl: './ui-card.component.html',
  styleUrl: './ui-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCardComponent {
  public readonly padding: InputSignal<UiCardPadding> = input<UiCardPadding>('md');
  public readonly elevated: InputSignal<boolean> = input<boolean>(true);

  protected readonly hasNoPadding: Signal<boolean> = computed((): boolean => this.padding() === 'none');
  protected readonly hasSmallPadding: Signal<boolean> = computed((): boolean => this.padding() === 'sm');
  protected readonly hasMediumPadding: Signal<boolean> = computed((): boolean => this.padding() === 'md');
}
